<template>
  <div class="image-container set-full-height">
    <!--   Creative Tim Branding   -->

    <!--  Made With Paper Kit  -->

    <!--   Big container   -->
    <div class="container" id="app">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-bottom: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red"> กลับสู่หน้า Home</button>
        </div>
        <div class="col-sm-8 col-sm-offset-2" style="background-color:#327339">
          <h3 align="center" style="color:#fff; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
            ม.สงขลานครินทร์
            <a href="index.html" style="color:#fff"><i class="ti-home"></i></a></h3>

          <!--      Wizard container        -->
          <div class="wizard-container">
            <div class="card wizard-card" data-color="red" id="wizard">
              <form action="" method="">

                <div class="wizard-header">
                  <h3 class="wizard-title" style="color:#000; font-family:Prompt"><u>แบบฟอร์มขอทำบัตรบุคลากร</u>
                  </h3>
                  <p class="category">====================================</p>
                </div>
                <div class="col-sm-12" align="center" style="margin-top: 35px">

                  <h5 class="info-text"
                      style="font-family:Prompt; text-align:center;background-color:#327339; color:#fff">
                    &nbsp;&nbsp;1. ข้อมูลส่วนตัว</h5>
                </div>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-select
                          outlined
                          :items="CardTypeSelect"
                          item-text="name"
                          item-value="value"
                          label="ประเภททำบัตร"
                          v-model="StatusRegis"
                          @change="CheckStatusRegis"
                          disabled
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item class="mt-4">
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="รหัสบุคลากร"
                                    readonly
                                    v-model="perid" id="perid"
                                    @keyup="FetchData(perid)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="ชื่อ(ภาษาไทย)"
                                    readonly
                                    v-model="nameTh" id="nameTh"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="นามสกุล(ภาษาไทย)"
                                    readonly
                                    v-model="surnameTh" id="surnameTh"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="ชื่อ(ภาษาอังกฤษ ตามบัตรประชาชน)"
                                    v-model="nameEn" id="nameEn"
                                    :error="nameEn == '' || nameEn == null"
                                    :error-messages="nameEn == '' || nameEn == null ? 'ชื่อ(ภาษาอังกฤษ) ห้ามว่าง**' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="นามสกุล(ภาษาอังกฤษ ตามบัตรประชาชน)"
                                    v-model="surnameEn" id="surnameEn"
                                    :error="surnameEn == '' || surnameEn == null"
                                    :error-messages="surnameEn == '' || surnameEn == null ? 'นามสกุล(ภาษาอังกฤษ) ห้ามว่าง**' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="8">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="hn (เลขบัตรโรงพยาบาล)"
                                    v-model="hn" id="hn"
                                    :error="hn == '' || hn == null"
                                    :error-messages="hn == '' || hn == null ? 'hn (เลขบัตรโรงพยาบาล) ห้ามว่าง**' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="8">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="ภาควิชา/หน่วยงาน"
                                    readonly
                                    v-model="depart" id="depart"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="โทรศัพท์หน่วยงาน"
                                    v-model="phoneDepart" id="phoneDepart"
                                    :error="phoneDepart == '' || phoneDepart == null"
                                    :error-messages="phoneDepart == '' || phoneDepart == null ? 'โทรศัพท์หน่วยงาน ห้ามว่าง**' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="โทรศัพท์เคลื่อนที่"
                                    v-model="phoneMoblie" id="phoneMoblie"
                                    :error="phoneMoblie == '' || phoneMoblie.length != 10"
                                    :error-messages="phoneMoblie == '' || phoneMoblie.length != 10 ? 'โทรศัพท์เคลื่อนที่ ห้ามว่าง**' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      md="6">
                      <v-text-field class="font-weight-bold"
                                    outlined
                                    label="โทรศัพท์บ้าน"
                                    v-model="phoneHome" id="phoneHome"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <div class="col-sm-12">
                  <h5 class="info-text"
                      style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                    &nbsp;&nbsp;2. ข้อมูลที่พักบุคลากร(ภายในคณะแพทยศาสตร์)</h5>
                </div>
                <div class="row">
                  <div class="col-sm-5 col-sm-offset-1">
                    <div class="form-group">
                      <label>หอพัก</label>
                      <input type="text" class="form-control" v-model="dorm" id="dorm"
                             placeholder="" value="-"
                             style="background-color:#9a9a9a;color: white" disabled>
                    </div>
                  </div>

                  <div class="col-sm-5">
                    <div class="form-group">
                      <label>ห้องพัก</label><br>
                      <input type="text" class="form-control" v-model="dorm2" id="dorm2"
                             placeholder="" value="-"
                             style="background-color:#9a9a9a;color: white" disabled>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12"><br>

                    <h5 class="info-text"
                        style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                      &nbsp;&nbsp;3. หลักฐานประกอบการทำบัตรบุคลากร</h5>
                  </div>

                  <div class="col-sm-10 col-sm-offset-1">
                    <div class="form-group" align="center" v-if="StatusRegis == '2'">
                      <input type="radio" style="transform: scale(1.5)" :checked="choosePic"
                             @click="ChoosePicRegis"><span style="margin-left: 10px">อัพโหลดรูปภาพใหม่</span>
                      <input type="radio" style="margin-left: 25px;transform: scale(1.5)"
                             :checked="!choosePic" @click="ChoosePicRegis"><span
                        style="margin-left: 10px">ใช้รูปภาพเดิม</span>
                    </div>
                    <div class="form-group" v-if="choosePic" style="font-weight: bold">
                                            <span :style="ChangeStyle">1) รูปถ่ายที่ใช้ในการทำบัตรบุคลากรคณะแพทยศาสตร์ ควรพิจารณาถึงความเหมาะสม สุภาพ
                                                 และเห็นใบหน้าอย่างชัดเจน แต่งกายชุดสุภาพหรือชุดที่แสดงถึงความเป็นวิชาชีพ ไม่สวมหมวกหรือแว่นตาแฟชั่น
                                                 ฉากพื้นหลังเป็นสีสุภาพหรือสีโทนอ่อนไม่มีลวดลาย เช่น สีฟ้าอ่อน สีครีม สีขาว ฯลฯ </span>
                      <input type="file" class="form-control" id="pic"
                             placeholder="" style="background-color:#dcfbdf"
                             @change="onFileSelected">
                    </div>
                    <div class="form-group">
                      <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                         v-if="ImageName == '' && choosePic">
                        รูปถ่าย ห้ามว่าง**
                      </p>
                    </div>
                    <div class="form-group" v-if="choosePic" style="font-weight: bold">
                      <span :style="ChangeStyle"> **** เหมาะสม สุภาพ ชัดเจน วิชาชีพ พื้นหลังเรียบโทนอ่อน **** <span
                          style="background-color: red;color: white"> ( ถ่ายมาแล้วไม่เกิน 6 เดือน )</span></span>
                    </div>
                  </div>

                  <div class="col-sm-10 col-sm-offset-1" align="center" v-if="StatusRegis == '2'">
                    <div class="form-group">
                      <label>2) ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์</label>
                      <input type="file" class="form-control" id="pic3"
                             placeholder="" style="background-color:#dcfbdf"
                             @change="FileSelectRecript">
                    </div>
                    <div class="form-group">
                      <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                         v-if="FileRecript == ''">
                        ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์ ห้ามว่าง**
                      </p>
                    </div>
                    <img v-if="ImageType" :src="pic_Recript"
                         class="img-responsive"/>
                    <iframe v-if="pdfType" :src="pic_Recript" style="width:400px; height:300px;"
                            frameborder="0"></iframe>
                  </div>

                </div>


                <div class="row" v-if="choosePic">
                  <div class="col-sm-12"><br>
                    <h5 class="info-text"
                        style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                      &nbsp;&nbsp;ตัวอย่างบัตร</h5>
                  </div>


                  <div class="col-sm-12" align="center">
                    <p style="font-family:Prompt;color: black;font-weight: bold">
                      เลือกตำแหน่งรูปภาพ</p>
                    <div style="border: 2px solid;border-color: #327339;padding: 10px">
                      <div class="cropper-wrapper" style="width: 100%;">
                        <div :style="{backgroundImage: 'url(' + pic_Profile + ')'}"
                             class="cropper-background"></div>
                        <Cropper
                            :rotatable="true"
                            :src="pic_Profile"
                            :restrictions="pixelsRestriction"
                            @change="onChangePic"
                        />
                      </div>
                      <button class="btn btn-warning" @click="rotate" style="margin-top: 15px">
                        ** หมุนรูปภาพ **
                      </button>
                    </div>

                  </div>

                  <div class="col-md-3 col-sm-12"></div>
                  <div class="col-md-6 col-sm-12" style="margin-top: 15px;height: fit-content;width: 100%"
                       align="center">
                    <div class="form-group"
                         style="text-align:center;height: 435px;width: fit-content">
                      <img src="../assets/img/card2.jpg" width="278" height="440">
                      <div style="top: -302px;position: relative;left: -39px;width: 162px"
                           align="right">
                        <span>{{ perid }}</span>
                      </div>
                      <div
                          style="top: -287px;position: relative;width: 124px;height: fit-content;float: left;margin: 0px;padding: 0px"
                          align="right">
                        <span>{{ hn }}</span>
                      </div>
                      <img :src="imageCrop" width="130" height="150"
                           :style="ShowPicCss">
                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                           align="right">
                        <span style="font-weight: bold">{{ nameTh }} {{ surnameTh }}</span>
                      </div>
                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                           align="right">
                        <span style="font-style: italic">{{ nameEn.toUpperCase() }} {{ surnameEn.toUpperCase() }}</span>
                      </div>
                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                           align="right">
                        <span style="font-weight: bold">{{ position }}</span>
                      </div>
                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                           align="right">
                        <span style="font-weight: bold">{{ depart.split(' ')[0] }}</span>
                      </div>
                      <div style="top: -308px;position: relative;width: fit-content"
                           align="left">
                        <span style="padding-left: 112px;font-weight: bold">{{ Date_Expire }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-12"></div>

                  <!--                                    แสดงหลังบัตร-->
                  <!--                                    <div class="col-sm-6" style="margin-top: 25px;;width: 100%" align="center">-->
                  <!--                                        <div class="form-group backimg" style="text-align:center">-->
                  <!--                                            <img src="../assets/img/card1.jpg" width="278" height="440">-->

                  <!--                                        </div>-->
                  <!--                                    </div>-->


                </div>


                <div class="row">
                  <div class="col-sm-12"><br>

                    <h5 class="info-text"
                        style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                      &nbsp;&nbsp;ยืนยันข้อมูลการขอทำบัตร</h5>
                  </div>

                  <div class="col-sm-10 col-sm-offset-1">
                    <div class="form-group">
                      <h3 align="center" style="font-family:Prompt;">
                        ยืนยันข้อมูลการทำบัตร </h3>
                    </div>
                  </div>
                  <div class="col-sm-12" align="center">
                    <div class="pull-center">
                      <input type='button' class='btn btn-fill btn-danger'
                             value='ยืนยันข้อมูล' v-on:click="SubmitForm" :disabled="CheckSubmit"/>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div> <!-- wizard container -->
          <h5 align="center" style="color:#fff; font-family:prompt;">
            ฝ่ายทรัพยากรมนุษย์ ชั้น 4 อาคารบริหารคณะแพทยศาสตร์ ติดต่อ 074-45-1141-2 email : person@medicine.psu.ac.th
          </h5>
        </div>
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-top: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red"> กลับสู่หน้า Home</button>
        </div>
      </div> <!-- row -->
    </div> <!--  big container -->
  </div>
</template>

<script>

import axios from 'axios'
import {Cropper} from 'vue-advanced-cropper'
import ConstData from '../Const/Const'
import queryString from "query-string";

const querystring = require('querystring');

export default {
  name: "Card1",
  data: function () {
    return {
      ChangeStyle: null,
      CheckSubmit: false,
      CardTypeSelect: [
        {
          'name': 'ใหม่',
          'value': '1'
        },
        {
          'name': 'หาย/ชำรุด',
          'value': '2'
        }
      ],
      ShowPicCss: '',
      valuePhoneMobileOld: '',
      choosePic: true,
      StatusRegis: '1',
      ImageType: false,
      pdfType: false,
      ImageName: '',
      errors: ["โปรดระบุข้อมูลโทรศัพท์เคลื่อนที่"],
      Date_Expire: '',
      perid: '',
      idcard: '',
      nameTh: '',
      nameEn: '',
      surnameTh: '',
      surnameEn: '',
      hn: '',
      brithDay: '',
      brithDayDB: '',
      gender: '',
      depart: '',
      phoneDepart: '',
      phoneMoblie: '',
      phoneHome: '',
      email: '',
      address: '',
      dorm: '',
      dorm2: '',
      car: '',
      car2: '',
      bike: '',
      bike2: '',
      options: {
        url: '/upload',
        paramName: 'file'
      },
      position: '',
      FilePersonal: '',
      FileRecript: '',
      FileHome: '',
      selectFile: '',
      pic_Profile: require('@/assets/img/NonPic.png'),
      pic_Recript: '',
      // pic_Profile: require('@/assets/img/ShowfPict.jpg'),
      dataFormSubmit: {
        request: {
          request_types_id: "1",
          request_wish_id: "1",
          quantity: "1",
          card_status: "1",
          expire_date: "",
        },
        items: [
          {
            person: {
              person_types_id: "1",
              perid: "",
              citizenId: "",
              firstName: "",
              lastName: "",
              firstNameEn: "",
              lastNameEn: "",
              hn: "",
              birthdate: "",
              sex: ""
            },
            contact: [
              {
                contact_types_id: "1",
                value: ""
              },
              {
                contact_types_id: "2",
                value: ""
              },
              {
                contact_types_id: "3",
                value: ""
              },
              {
                contact_types_id: "4",
                value: ""
              },
              {
                contact_types_id: "5",
                value: ""
              },
              {
                contact_types_id: "6",
                value: ""
              }
            ],
            dorm: [
              {
                dorm_types_id: "1",
                value: "-"
              },
              {
                dorm_types_id: "2",
                value: "-"
              }
            ],
            vehicle: [],
            attachment: [
              {
                attachment_types_id: "1",
                url: ""
              },
              {
                attachment_types_id: "2",
                url: ""
              },
              {
                attachment_types_id: "3",
                url: ""
              },
              {
                attachment_types_id: "4",
                url: ""
              },
              {
                attachment_types_id: "5",
                url: ""
              }
            ]
          }
        ]
      },
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      imageCrop: null
    };
  },
  methods: {
    rotate() {
      var image = document.createElement("img");
      image.crossOrigin = "anonymous";
      image.src = this.pic_Profile;
      image.onload = () => {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        if (image.width > image.height) {
          canvas.width = image.height;
          canvas.height = image.width;
          ctx.translate(image.height, image.width / image.height);
        } else {
          canvas.height = image.width;
          canvas.width = image.height;
          ctx.translate(image.height, image.width / image.height);
        }
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, 0, 0);
        this.pic_Profile = canvas.toDataURL();
      };
    },
    gotoPage() {
      window.open(ConstData.ConnectionHost + '/personnel')
    },
    SetStyle() {
      if (this.hn == null || this.hn == '') {
        this.ShowPicCss = {
          "position": "relative",
          "top": "-345px",
          "object-fit": "contain",
          "left": "65px"
        }
      } else {
        this.ShowPicCss = {
          "position": "relative",
          "top": "-345px",
          "object-fit": "contain"
        }
      }
    },
    SendLineNotify() {
      var TypeCard = ''
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear() + 543;
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      if (hour.toString().length == 1) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      if (second.toString().length == 1) {
        second = '0' + second;
      }

      today = dd + '/' + mm + '/' + yyyy + ' ' + hour + ':' + minute + ':' + second

      if (this.StatusRegis == '1') {
        TypeCard = 'ทำบัตรใหม่'
      } else {
        TypeCard = 'บัตรหาย/ชำรุด'
      }

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/line_noti/').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              if (item.type == '1') {

                const param = querystring.stringify(
                    {
                      message: 'มีรายการสมัครบัตรบุคลากร แจ้งรายการ ( ' + TypeCard + ' ) เข้ามาใหม่ ' +
                          ' ชื่อ - สกุล ( ' + this.nameTh + ' ' + this.surnameTh + ' ) รหัสบุคลากร ( ' + this.perid + ' ) สมัครเมื่อวันที่ ' +
                          today,
                      Token: item.Line_Token
                    }
                )

                axios.post(ConstData.ConnectionHost + '/sendLineNotify.php', param)
              }
            })
          } else {
            if (res.data.type == '1') {

              const param = querystring.stringify(
                  {
                    message: 'มีรายการสมัครบัตรบุคลากร แจ้งรายการ ( ' + TypeCard + ' ) เข้ามาใหม่ ' +
                        ' ชื่อ - สกุล ( ' + this.nameTh + ' ' + this.surnameTh + ' ) รหัสบุคลากร ( ' + this.perid + ' ) สมัครเมื่อวันที่ ' +
                        today,
                    Token: res.data.Line_Token
                  }
              )

              axios.post(ConstData.ConnectionHost + '/sendLineNotify.php', param)
            }
          }
        }
      })
    },
    ChoosePicRegis: function () {
      if (this.choosePic) {
        this.choosePic = false

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/1/perid/' + this.perid + '/?sort=id_DESC&limit=1').then(res => {
          if (res.data) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment_view/person_id/' + res.data.person_id).then(res => {
              if (res.data) {
                this.dataFormSubmit.items[0].attachment[0].url = res.data[0].url
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถแจ้งบัตรหายได้ เนื่องจากไม่มีข้อมูลการทำบัตรมาก่อน'
            })
          }
        })
      } else {
        this.choosePic = true
      }
    },
    onChangePic({coordinates, canvas}) {
      this.coordinates = coordinates
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      // this.imageCrop = canvas.toDataURL("image/png")
      this.imageCrop = canvas.toDataURL()
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type: mimeString});
    },
    pixelsRestriction({minWidth, minHeight, maxWidth, maxHeight}) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
      }
    },
    checkForm: function (e) {

      if (this.phoneMoblie.length <= 10) {
        this.valuePhoneMobileOld = this.phoneMoblie
      } else {
        this.phoneMoblie = this.valuePhoneMobileOld
      }

      if (this.phoneMoblie) {
        this.errors = [];
      } else {
        this.errors.push("โปรดระบุข้อมูลโทรศัพท์เคลื่อนที่");
      }
      e.preventDefault();
    },
    SubmitForm: function () {
      if (this.nameEn == '' || this.surnameEn == '' || this.hn.trim() == '' || this.selectFile == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดกรอกข้อมูลให้ครบถ้วน'
        })
      } else if (this.phoneDepart == '' || this.phoneMoblie == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดกรอกข้อมูลให้ครบถ้วน'
        })
      } else if (this.phoneMoblie.length != 10) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดกรอกข้อมูลหมายเลขโทรศัพท์เคลื่อนที่ให้ครบ 10 หลัก'
        })
      } else {
        this.submitData()
      }
    },
    submitData: function () {
      this.CheckSubmit = true
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/perid/' + this.perid + '/request_types_id/1/card_status/1/?sort=id_DESC&limit=1').then(res => {
        if (res.data) {
          if (res.data.status_id == '5' || res.data.status_id == '3') {

            var DateNow = new Date()
            var DateMatch = new Date(res.data.expire_date)

            if (DateNow.getTime() < DateMatch.getTime() && this.StatusRegis == '1' && res.data.status_id != '3') {
              this.CheckSubmit = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถสมัครบัตรบุตลากรใหม่ได้',
                text: 'เนื่องจาก ยังไม่ถึงกำหนดวันหมดอายุของบัตร'
              })
            } else {
              var blobImage = this.dataURItoBlob(this.imageCrop)
              // this.imageCrop = canvas.toDataURL()
              window.console.log(blobImage)
              const fd = new FormData()
              fd.append('file', blobImage, this.ImageName)
              const headerAxiosUploadFile = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              if (!this.choosePic) {

                this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 6) + '-09-30'

                this.dataFormSubmit.items[0].person.perid = this.perid
                this.dataFormSubmit.items[0].person.citizenId = this.idcard
                this.dataFormSubmit.items[0].person.firstName = this.nameTh
                this.dataFormSubmit.items[0].person.lastName = this.surnameTh
                //-------------- เฉพาะแพทย์ -------------//
                this.dataFormSubmit.items[0].person.firstNameEn = this.nameEn.toUpperCase()
                this.dataFormSubmit.items[0].person.lastNameEn = this.surnameEn.toUpperCase()
                this.dataFormSubmit.items[0].person.hn = this.hn
                //-------------- เฉพาะแพทย์ -------------//
                this.dataFormSubmit.items[0].person.birthdate = this.brithDayDB
                this.dataFormSubmit.items[0].person.sex = (this.gender == '2' ? 'M' : 'F');

                this.dataFormSubmit.items[0].contact.map((element) => {
                  switch (element.contact_types_id) {
                    case "1":
                      element.value = this.email;
                      break;
                    case "2":
                      element.value = this.depart;
                      break;
                    case "3":
                      element.value = this.phoneDepart;
                      break;
                    case "4":
                      element.value = this.phoneMoblie;
                      break;
                    case "5":
                      element.value = this.phoneHome;
                      break;
                    default:
                      element.value = this.address;
                      break;
                  }
                })

                if (!this.choosePic) {
                  this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                    switch (attachmentData.attachment_types_id) {
                      case "1":
                        break;
                      case "2" :
                        attachmentData.url = this.FilePersonal;
                        break;
                      case "3" :
                        attachmentData.url = this.FileRecript;
                        break;
                      case "4" :
                        attachmentData.url = this.FileHome;
                        break;
                      default :
                        break;
                    }
                  })
                } else {
                  this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                    switch (attachmentData.attachment_types_id) {
                      case "1":
                        attachmentData.url = this.selectFile;
                        break;
                      case "2" :
                        attachmentData.url = this.FilePersonal;
                        break;
                      case "3" :
                        attachmentData.url = this.FileRecript;
                        break;
                      case "4" :
                        attachmentData.url = this.FileHome;
                        break;
                      default :
                        break;
                    }
                  })
                }


                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }

                axios
                    .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                    .then(res => {
                      if (res.data.status) {
                        this.SendLineNotify()
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.$router.push('/')
                      } else {
                        this.CheckSubmit = false
                        this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                      }
                    })
              } else {
                axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxiosUploadFile).then(res => {
                  if (res.data.status) {
                    this.selectFile = res.data.path

                    this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 6) + '-09-30'

                    this.dataFormSubmit.items[0].person.perid = this.perid;
                    this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                    this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                    this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                    //-------------- เฉพาะแพทย์ -------------//
                    this.dataFormSubmit.items[0].person.firstNameEn = this.nameEn.toUpperCase()
                    this.dataFormSubmit.items[0].person.lastNameEn = this.surnameEn.toUpperCase()
                    this.dataFormSubmit.items[0].person.hn = this.hn
                    //-------------- เฉพาะแพทย์ -------------//
                    this.dataFormSubmit.items[0].person.birthdate = this.brithDayDB;
                    this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');

                    this.dataFormSubmit.items[0].contact.map((element) => {
                      switch (element.contact_types_id) {
                        case "1":
                          element.value = this.email;
                          break;
                        case "2":
                          element.value = this.depart;
                          break;
                        case "3":
                          element.value = this.phoneDepart;
                          break;
                        case "4":
                          element.value = this.phoneMoblie;
                          break;
                        case "5":
                          element.value = this.phoneHome;
                          break;
                        default:
                          element.value = this.address;
                          break;
                      }
                    })

                    if (!this.choosePic) {
                      this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                        switch (attachmentData.attachment_types_id) {
                          case "1":
                            break;
                          case "2" :
                            attachmentData.url = this.FilePersonal;
                            break;
                          case "3" :
                            attachmentData.url = this.FileRecript;
                            break;
                          case "4" :
                            attachmentData.url = this.FileHome;
                            break;
                          default :
                            break;
                        }
                      })
                    } else {
                      this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                        switch (attachmentData.attachment_types_id) {
                          case "1":
                            attachmentData.url = this.selectFile;
                            break;
                          case "2" :
                            attachmentData.url = this.FilePersonal;
                            break;
                          case "3" :
                            attachmentData.url = this.FileRecript;
                            break;
                          case "4" :
                            attachmentData.url = this.FileHome;
                            break;
                          default :
                            break;
                        }
                      })
                    }


                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }

                    axios
                        .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                        .then(res => {
                          if (res.data.status) {
                            this.SendLineNotify()
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.$router.push('/')
                          } else {
                            this.CheckSubmit = false
                            this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                          }
                        })
                  } else {
                    this.selectFile = ''
                  }
                })

              }
            }
          } else {
            this.CheckSubmit = false
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จ',
              text: 'เนื่องจาก มีข้อมูลคำร้องขอทำบัตรที่ยังไม่เสร็จสิ้นขั้นตอนการจ่ายบัตร'
            })
          }
        } else {
          var blobImage2 = this.dataURItoBlob(this.imageCrop)
          // this.imageCrop = canvas.toDataURL()
          window.console.log(blobImage2)
          const fd = new FormData()
          fd.append('file', blobImage2, this.ImageName)
          const headerAxiosUploadFile = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          if (!this.choosePic) {
            this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 6) + '-09-30'
            this.dataFormSubmit.items[0].person.perid = this.perid
            this.dataFormSubmit.items[0].person.citizenId = this.idcard
            this.dataFormSubmit.items[0].person.firstName = this.nameTh
            this.dataFormSubmit.items[0].person.lastName = this.surnameTh
            //-------------- เฉพาะแพทย์ -------------//
            this.dataFormSubmit.items[0].person.firstNameEn = this.nameEn.toUpperCase()
            this.dataFormSubmit.items[0].person.lastNameEn = this.surnameEn.toUpperCase()
            this.dataFormSubmit.items[0].person.hn = this.hn
            //-------------- เฉพาะแพทย์ -------------//
            this.dataFormSubmit.items[0].person.birthdate = this.brithDayDB
            this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');

            this.dataFormSubmit.items[0].contact.map((element) => {
              switch (element.contact_types_id) {
                case "1":
                  element.value = this.email;
                  break;
                case "2":
                  element.value = this.depart;
                  break;
                case "3":
                  element.value = this.phoneDepart;
                  break;
                case "4":
                  element.value = this.phoneMoblie;
                  break;
                case "5":
                  element.value = this.phoneHome;
                  break;
                default:
                  element.value = this.address;
                  break;
              }
            })

            if (!this.choosePic) {
              this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                switch (attachmentData.attachment_types_id) {
                  case "1":
                    break;
                  case "2" :
                    attachmentData.url = this.FilePersonal;
                    break;
                  case "3" :
                    attachmentData.url = this.FileRecript;
                    break;
                  case "4" :
                    attachmentData.url = this.FileHome;
                    break;
                  default :
                    break;
                }
              })
            } else {
              this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                switch (attachmentData.attachment_types_id) {
                  case "1":
                    attachmentData.url = this.selectFile;
                    break;
                  case "2" :
                    attachmentData.url = this.FilePersonal;
                    break;
                  case "3" :
                    attachmentData.url = this.FileRecript;
                    break;
                  case "4" :
                    attachmentData.url = this.FileHome;
                    break;
                  default :
                    break;
                }
              })
            }


            const headerAxios = {
              headers: {
                'Content-Type': 'application/json'
              }
            }

            axios
                .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                .then(res => {
                  if (res.data.status) {
                    this.SendLineNotify()
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.$router.push('/')
                  } else {
                    this.CheckSubmit = false
                    this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                  }
                })
          } else {
            window.console.log(fd)
            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxiosUploadFile).then(res => {
              window.console.log(res.data)
              if (res.data.status) {
                this.selectFile = res.data.path
                this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 6) + '-09-30'
                this.dataFormSubmit.items[0].person.perid = this.perid;
                this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                //-------------- เฉพาะแพทย์ -------------//
                this.dataFormSubmit.items[0].person.firstNameEn = this.nameEn.toUpperCase()
                this.dataFormSubmit.items[0].person.lastNameEn = this.surnameEn.toUpperCase()
                this.dataFormSubmit.items[0].person.hn = this.hn
                //-------------- เฉพาะแพทย์ -------------//
                this.dataFormSubmit.items[0].person.birthdate = this.brithDayDB;
                this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');

                this.dataFormSubmit.items[0].contact.map((element) => {
                  switch (element.contact_types_id) {
                    case "1":
                      element.value = this.email;
                      break;
                    case "2":
                      element.value = this.depart;
                      break;
                    case "3":
                      element.value = this.phoneDepart;
                      break;
                    case "4":
                      element.value = this.phoneMoblie;
                      break;
                    case "5":
                      element.value = this.phoneHome;
                      break;
                    default:
                      element.value = this.address;
                      break;
                  }
                })

                if (!this.choosePic) {
                  this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                    switch (attachmentData.attachment_types_id) {
                      case "1":
                        break;
                      case "2" :
                        attachmentData.url = this.FilePersonal;
                        break;
                      case "3" :
                        attachmentData.url = this.FileRecript;
                        break;
                      case "4" :
                        attachmentData.url = this.FileHome;
                        break;
                      default :
                        break;
                    }
                  })
                } else {
                  this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                    switch (attachmentData.attachment_types_id) {
                      case "1":
                        attachmentData.url = this.selectFile;
                        break;
                      case "2" :
                        attachmentData.url = this.FilePersonal;
                        break;
                      case "3" :
                        attachmentData.url = this.FileRecript;
                        break;
                      case "4" :
                        attachmentData.url = this.FileHome;
                        break;
                      default :
                        break;
                    }
                  })
                }


                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }

                axios
                    .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                    .then(res => {
                      if (res.data.status) {
                        this.SendLineNotify()
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.$router.push('/')
                      } else {
                        this.CheckSubmit = false
                        this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                      }
                    })
              } else {
                this.selectFile = ''
              }
            })

          }
        }
      })

      // var self = this;
      // window.console.log(self.dataFormSubmit)
    },
    FileSelectPersonal: function (event) {
      if (event.target.files[0]) {
        const fd = new FormData()
        fd.append('file', event.target.files[0], event.target.files[0].name)
        const headerAxios = {
          headers: {
            'Content-Type': 'multipart/form-data',
            'WithCredentials': true,
            "Access-Control-Allow-Origin": "*"
            // "Accept": 'multipart/form-data'
          }
        }

        axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
          if (res.data.status) {
            this.FilePersonal = res.data.path
          } else {
            this.FilePersonal = ''
          }
        })
      } else {
        this.FilePersonal = ''
      }

    },
    FileSelectRecript: function (event) {
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImageType = true
            this.pdfType = false
            this.pic_Recript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfType = true
            this.ImageType = false
            this.pic_Recript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImageType = false
            this.pdfType = false
            this.pic_Recript = ''
            break
        }
        if (Checkfile) {
          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
          } else {
            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                this.FileRecript = res.data.path
              } else {
                this.FileRecript = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }

      } else {
        this.ImageType = false
        this.pdfType = false
        this.pic_Recript = ''
        this.FileRecript = ''
      }
    },
    FileSelectHome: function (event) {
      if (event.target.files[0]) {
        const fd = new FormData()
        fd.append('file', event.target.files[0], event.target.files[0].name)
        const headerAxios = {
          headers: {
            'Content-Type': 'multipart/form-data',
            'WithCredentials': true,
            "Access-Control-Allow-Origin": "*"
            // "Accept": 'multipart/form-data'
          }
        }

        axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
          if (res.data.status) {
            this.FileHome = res.data.path
          } else {
            this.FileHome = ''
          }
        })
      } else {
        this.FileHome = ''
      }
    },
    onFileSelected: function (event) {

      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            Checkfile = true;
            break
          default:
            Checkfile = false;
            break
        }
        if (Checkfile) {
          /* if (event.target.files[0].size > 2048 * 2048) {
               this.$swal.fire({
                   icon: 'error',
                   title: 'พบข้อผิดพลาด',
                   text: 'ไม่สนับสนุนไฟล์เกิน 2 mb'
               })
           } else {*/
          this.ImageName = event.target.files[0].name;

          if (event.target.files[0]) {
            this.url = URL.createObjectURL(event.target.files[0])
            this.pic_Profile = this.url
            // this.pic_Profile = require('@/assets/img/ShowfPict.jpg')
          } else {
            this.pic_Profile = require('@/assets/img/NonPic.png')
          }

          this.selectFile = event.target.files[0].name

          // this.selectFile = this.onUpload(this.selectFile);

          /*const fd = new FormData()
          fd.append('file', event.target.files[0], event.target.files[0].name)
          const headerAxios = {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
              }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                  this.selectFile = res.data.path
              } else {
                  this.selectFile = ''
              }
          })*/
          /*}*/

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }

      } else {
        this.ImageName = ''
        this.selectFile = ''
        this.pic_Profile = require('@/assets/img/NonPic.png')
      }
    },
    getExtension(filename) {
      var parts = filename.split('.');
      return parts[parts.length - 1];
    },
    onUpload: function (dataFile) {
      const fd = new FormData()
      fd.append('file', dataFile, dataFile.name)
      const headerAxios = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'WithCredentials': true,
          "Access-Control-Allow-Origin": "*"
          // "Accept": 'multipart/form-data'
        }
      }

      axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
        if (res.data.status) {
          return res.data.path
        } else {
          return null
        }
      })
    },
    CheckStatusRegis: function () {
      if (this.StatusRegis == 1) {
        this.choosePic = true;
        this.dataFormSubmit.request.request_wish_id = '1';
      } else {
        this.dataFormSubmit.request.request_wish_id = '2';
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/perid/' + this.perid + '/request_types_id/1/?sort=id_DESC&limit=1').then(res => {
          if (res.data) {
            axios.get(ConstData.ConnectionHost + '/dorm/' + res.data.perid + '/room-history').then(personV => {
              if (personV.data.data.length > 0) {
                this.dorm = personV.data.data[0][1]
                this.dorm2 = personV.data.data[0][0]
              }
            })
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact_view/request_id/' + res.data.id).then(contactV => {
              if (contactV.data) {
                this.phoneMoblie = contactV.data[3].value
              }
            })
          }
        })
      }
    },
    blackMenu: function () {
      this.$router.push('/')
    },
    parseJwt: function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
  },
  components: {
    Cropper
  },
  mounted() {
    // if (new Date() >= new Date('2020-10-27')) {
    //     this.$swal.fire({
    //         icon: 'error',
    //         title: 'ขออภัย!!!',
    //         text: 'หมดระยะเวลาการทำบัตรบุคลากร'
    //     })
    //     this.$router.push('/')
    // } else {
    axios.post(ConstData.ConnectionHost + '/saveSessions.php', queryString.stringify({
      session: 'https://medhr.medicine.psu.ac.th/CardRegister/#/Card1'
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    setInterval(() => {
      this.ChangeStyle = {
        "font-weight: bold": "bold",
        "font-size": "16px",
        "color": "red",
        "text-shadow": "0px 0px 50px rgba(255, 0, 0, 1)"
      }
    }, 1000)
    setInterval(() => {
      this.ChangeStyle = {
        "font-weight: bold": "bold",
        "font-size": "16px",
        "color": "blue",
        "text-shadow": "0px 0px 50px rgba(0, 30, 255, 1)"
      }
    }, 1500)
    var DateNow = new Date();
    DateNow.setFullYear(DateNow.getFullYear() + 6);
    this.Date_Expire = '30 กันยายน ' + (DateNow.getFullYear() + 543);
    if (this.$cookies.get('access_token')) {
      axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
        "queryName": "checkPdpa",
        "param": {
          "PERID": this.parseJwt(this.$cookies.get('access_token')).perid
        }
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        if (res.data.length > 0) {
          if (res.data[0].pdpa_agreement == '1') {
            axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
              queryName: 'PersonalDataByPerson',
              param: btoa(encodeURIComponent(JSON.stringify({
                perid: this.parseJwt(this.$cookies.get('access_token')).perid
              })))
            }).then(res => {
              if (res.data && res.data.staffData.length > 0) {
                this.perid = res.data.staffData[0].perid
                this.nameTh = res.data.staffData[0].name
                this.surnameTh = res.data.staffData[0].surname
                this.depart = res.data.staffData[0].dep_group_name
                this.position = res.data.staffData[0].pos_name
                this.nameEn = res.data.staffData[0].nameEn
                this.surnameEn = res.data.staffData[0].surnameEn
                this.hn = res.data.staffData[0].hn
                this.brithDay = res.data.staffData[0].birthdate
                this.brithDayDB = res.data.staffData[0].birthdate
                this.gender = res.data.staffData[0].sex
                this.idcard = ""

                if (res.data.dormData != null && res.data.dormData.length > 0) {
                  this.dorm = res.data.dormData[0].room_name
                  this.dorm2 = res.data.dormData[0].dorm_name
                }

                if (res.data.contextData != null && res.data.contextData.length > 0) {
                  res.data.contextData.map(contextI => {
                    if (contextI.contact_type_id == '1') {
                      this.phoneMoblie = contextI.data
                    }
                  })
                }

                if (this.hn == null || this.hn.trim() == '') {
                  this.ShowPicCss = {
                    "position": "relative",
                    "top": "-345px",
                    "object-fit": "contain",
                    "left": "65px"
                  }
                } else {
                  this.ShowPicCss = {
                    "position": "relative",
                    "top": "-345px",
                    "object-fit": "contain"
                  }
                }
              }
            })

          } else {
            alert('โปรดจัดทำข้อตกลง PDPA ก่อนดำเนินการทำบัตรบุคลากร');
            window.location.href = ConstData.ConnectionHost + '/PDPA/pdpa_complete';
            // this.$swal.fire({
            //   icon: 'warning',
            //   title: 'พบข้อผิดพลาด',
            //   html: 'โปรดจัดทำข้อตกลง PDPA ก่อนดำเนินการทำบัตรบุคลากร สามารถทำข้อตกลง PDPA ได้ตามลิงค์ <br /> <a href="https://medhr.medicine.psu.ac.th/PDPA/pdpa_complete">เปิดลิงค์ทำข้อตกลง PDPA</a>'
            // })
          }
        } else {
          this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
          this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
          window.location.href = ConstData.ConnectionHost + '/SingleSign/';
        }
      }).catch(res => {
        console.log(res)
        this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
        this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
        window.location.href = ConstData.ConnectionHost + '/SingleSign/';
      })
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
    } else {
      // this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

      // this.$cookies.remove('access_token')
      this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
      this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/Card1')
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
      // window.location.href = ConstData.ConnectionHost + '/SingleSign/perid_login';
    }

    /*if (this.$cookies.get('access_token')) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
    } else {
        this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

        /!*this.$session.set('vurl',ConstData.ConnectionHost + '/CardRegister/#/Card2')
        window.location.href = ConstData.ConnectionHost + '/SingleSign/';*!/
    }*/
    // }
  }
}
</script>

<style scoped>
img {
  image-orientation: from-image;
}

.swal2-popup {
  font-size: 1.6rem !important;
}

.cropper-wrapper {
  position: relative;
  height: 350px;
  width: 400px;
  background: black;
  padding: 5px;
}

.cropper-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50%;
  filter: blur(5px);
  opacity: 0.25;
}

.backimg {

}
</style>
